import { isError } from 'lodash';
import { alignmentType } from '../../../../interfaces/interfaces';
import styles from './TableForm.module.scss';

type Props = {
    gridStyles?: React.CSSProperties,
    headerColumns: {
        title: string,
        key: string,
        width: string,
        alignment: alignmentType
    }[],
    footerText: React.ReactNode,
    children: any;
    hideHeader?: boolean;
}

export const TableForm = ({ headerColumns, gridStyles, footerText, hideHeader = false, children }: Props) => {


    return (
        <div className={styles.tableRootContainer}>
            <div className={styles.tableParentContainer}>
                <table className={styles.tableContainer}>
                    {hideHeader ? null : <thead >
                        <tr>
                            {headerColumns.map((item, index) => {
                                return (
                                    <th style={{ width: item.width }} key={item.key} className={`${styles.tableHeader}`}>
                                        <div className={`${styles.tableCell} ${styles[item.alignment]}`}>
                                            {item.title}
                                        </div>
                                    </th>
                                )
                            })}
                        </tr>
                    </thead>}
                    <tbody>
                        {children}
                    </tbody>
                </table>
            </div>
            {footerText ? <div className={styles.footerText}>
                {footerText}
            </div> : null}
        </div>

    );
}

type TableBodyProps = {
    alignment?: alignmentType,
    children: React.ReactNode,
    isError?: boolean
    styles?: React.CSSProperties
    colSpan?: number;
    innerDivStyles?: React.CSSProperties;
}

type TableRowProps = {
    isVisible?: boolean,
    animation?: boolean,
    children: React.ReactNode,
    hideBorder?: boolean;
    id?: string;
}

export const TableFormRow = ({ children, isVisible = true, hideBorder = false, animation = false, id = "" }: TableRowProps) => {


    return (
        <tr id={id} className={`${styles.tableRow} ${hideBorder ? styles.hideBorder : ''} ${animation ? isVisible ? `${styles.animation} ${styles.visible}` : `${styles.animation} ${styles.hidden}` : ''}`}>
            {children}
        </tr>
    )
}

export const TableFormBody = ({ alignment = alignmentType.centerAlign, colSpan = 1, isError = false, styles: inlineStyles = {}, innerDivStyles = {}, children }: TableBodyProps) => {

    return (
        <td colSpan={colSpan} className={`${styles.tableBody} ${isError ? styles.error : ''}`} style={{ ...inlineStyles }}>
            <div className={`${styles.tableCell} ${styles[alignment]}`} style={{ ...innerDivStyles }}>
                {children}
            </div>
        </td>
    );
}

